<template>
  <cac-page>
    <welcome-banner
      :page-key="componentUniqueKey"
    />
  </cac-page>
</template>

<script>
import { mapGetters } from "vuex";
import STATE from "Constants/campaign/civicactioncenter/state";
import CacPage from "CivicActionCenterComponents/layout/CACPage.vue";
import WelcomeBanner from "CivicActionCenterComponents/sections/WelcomeBanner.vue";
import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";

const hasAdvocateContext = `${STATE.SCOPE_CAC}/${STATE.HAS_ADVOCATE}`;

export default {
  name: "RegisterToVoteBanner",
  components: {
    CacPage,
    WelcomeBanner
  },
  mixins: [SharedMixin],
  computed: {
    ...mapGetters({
      hasAdvocate: hasAdvocateContext
    })
  }
};
</script>
